export default class ThreadImageInput {
  constructor({ rootElement = document, imageContainerSelectors, fileInputSelectors, fileInputIconSelectors }) {
    this.imageContainer = rootElement.querySelector(imageContainerSelectors);
    this.fileInput = rootElement.querySelector(fileInputSelectors);
    this.fileInputIcon = rootElement.querySelector(fileInputIconSelectors);
    this.selectedFiles = [];
    if (!this.imageContainer || !this.fileInput || !this.fileInputIcon) return;

    this.fileInputIcon.addEventListener("click", () => { this.fileInput.click(); });
    this.boundHandleImageUpload = this.handleImageUpload.bind(this);
    this.fileInput.addEventListener("change", this.boundHandleImageUpload);
  }

  handleImageUpload(event) {
    this.clearImageContainer();
    this.selectedFiles = Array.from(event.target.files);
    this.selectedFiles.forEach(file => {
      const reader = new FileReader();
      reader.onload = e => this.createImageElement(e, file);
      reader.readAsDataURL(file);
    });
  }

  clearImageContainer() {
    while (this.imageContainer.firstChild) {
      this.imageContainer.removeChild(this.imageContainer.firstChild);
    }
  }

  createImageElement(e, file) {
    const imgWrapper = document.createElement("div");
    imgWrapper.classList.add("relative");

    const img = this.createImage(e.target.result);
    const closeButton = this.createCloseButton(file);

    imgWrapper.appendChild(img);
    imgWrapper.appendChild(closeButton);
    this.imageContainer.appendChild(imgWrapper);
    this.imageContainer.classList.remove("hidden");
  }

  createImage(src) {
    const img = document.createElement("img");
    img.src = src;
    img.classList.add("w-14", "h-14", "md:w-16", "md:h-16", "object-cover", "rounded-lg");
    return img;
  }

  createCloseButton(file) {
    const closeButton = document.createElement("button");
    closeButton.textContent = "×";
    closeButton.classList.add("p-room_thread-img-delete-btn", "absolute", "-top-3", "-right-3", "w-6", "h-6", "rounded-full");
    closeButton.addEventListener("click", () => {
      this.removeImage(file, closeButton.parentElement);
    });
    return closeButton;
  }

  removeImage(file, imgWrapper) {
    this.imageContainer.removeChild(imgWrapper);
    this.selectedFiles = this.selectedFiles.filter(selectedFile => selectedFile !== file);
    const dataTransfer = new DataTransfer();
    this.selectedFiles.forEach(selectedFile => dataTransfer.items.add(selectedFile));
    this.fileInput.files = dataTransfer.files;
    if (this.imageContainer.childNodes.length === 0) {
      this.imageContainer.classList.add("hidden");
    }
  }
}
